<form class="p-3 pt-0 pb-0">
  <div class="row">
    <div class="col-12 col-md-6">
      <label>Temporada</label>
      <select
        (change)="selectSeason($event.target.value)"
        [ngModel]="seasonID"
        [ngModelOptions]="{standalone: true}"
        class="form-control"
      >
        <option value="">Selecciona una temporada</option>
        <option *ngFor="let season of agricolaSeasons" [value]="season.id">
          {{season.name}}
        </option>
      </select>
    </div>
    <div class="col-12 col-md-6 d-flex justify-content-end align-items-center">
      <button class="btn btn-primary" (click)="setCycle()">
        Guardar ciclo
      </button>
    </div>
  </div>
  <div class="d-flex justify-content-center">
    <ngb-datepicker
      #dp
      (dateSelect)="onDateSelection($event)"
      [displayMonths]="displayMonths"
      [dayTemplate]="t"
      [startDate]="fromDate"
      outsideDays="hidden"
    >
    </ngb-datepicker>
    <ng-template #t let-date let-focused="focused">
      <span
        class="custom-day"
        [class.focused]="focused"
        [class.range]="isRange(date)"
        [class.faded]="isHovered(date) || isInside(date)"
        (mouseenter)="hoveredDate = date"
        (mouseleave)="hoveredDate = null"
      >
        {{ date.day }}
      </span>
    </ng-template>
  </div>
</form>
